<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-center justify-between bg-primary-50 px-6 dark:bg-primary-900/10"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <div class="flex items-center gap-2">
      <mat-icon class="text-primary" fontSet="material-icons-outlined">description</mat-icon>
      <div>
        <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.TITLE' | t }}</h2>
        @if (!shortScreen) {
        <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.SUBTITLE' | t }}</span>
        }
      </div>
    </div>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- body -->
  <div class="min-h-0 flex-1 overflow-auto px-6 py-5">
    <!-- aviso de partición: lo primero que se lee, porque cambia lo que se va a obtener -->
    @if (showsSplitNotice) {
    <div class="mb-6 flex flex-col gap-3 rounded-xl border-2 border-amber-400 bg-amber-50 px-5 py-4 dark:bg-amber-900/20 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-start gap-3">
        <mat-icon class="icon-size-6 shrink-0 text-amber-600" fontSet="material-icons-outlined">warning_amber</mat-icon>
        <div class="flex flex-col gap-1">
          <span class="text-sm">
            <span [innerHTML]="'DOCUMENT_GENERATE.PREVIEW_MODAL.SPLIT_NOTICE' | t: { documentClass: documentClassLabel, config: splitNoticeConfig }"></span>
          </span>
          <span class="text-sm font-semibold">{{ splitNoticeResult }}</span>
        </div>
      </div>
      @if (isSplit) {
      <button mat-flat-button color="primary" type="button" class="shrink-0" (click)="openSplit()">
        <mat-icon>call_split</mat-icon>
        {{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.VIEW_SPLIT' | t: { count: documentCount } }}
      </button>
      }
    </div>
    }

    <!-- datos generales -->
    <h3 class="text-base font-bold">{{ 'DOCUMENT_GENERATE.SECTIONS.GENERAL_DATA' | t }}</h3>
    <div class="mb-6 mt-3 grid grid-cols-1 gap-x-8 gap-y-4 rounded-xl bg-gray-50 p-5 dark:bg-transparent sm:grid-cols-2 lg:grid-cols-3">
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_TYPE' | t }}</span>
        <span class="font-medium">{{ data.documentTypeLabel || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_CLASS' | t }}</span>
        <span class="font-medium">{{ data.documentClass || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t }}</span>
        <span class="font-medium">{{ data.salesOffice || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.SHIP_TO' | t }}</span>
        <span class="font-medium">{{ data.shipTo || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.SOLD_TO' | t }}</span>
        <span class="font-medium">{{ data.soldTo || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.SHIPPING_ADDRESS' | t }}</span>
        <span class="font-medium">{{ data.address || '-' }}</span>
      </div>
    </div>

    <!-- logística -->
    <h3 class="text-base font-bold">{{ 'DOCUMENT_GENERATE.SECTIONS.LOGISTICS' | t }}</h3>
    <div class="mb-6 mt-3 grid grid-cols-1 gap-x-8 gap-y-4 rounded-xl bg-gray-50 p-5 dark:bg-transparent sm:grid-cols-2 lg:grid-cols-3">
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.WAREHOUSE' | t }}</span>
        <span class="font-medium">{{ data.warehouse || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.EXPEDITION_CONDITION' | t }}</span>
        <span class="font-medium">{{ data.expeditionCondition || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.PAYMENT_CONDITION' | t }}</span>
        <span class="font-medium">{{ data.paymentCondition || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.REFERENCE' | t }}</span>
        <span class="font-medium">{{ data.reference || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.CREATED_DATE' | t }}</span>
        <span class="font-medium">{{ (data.documentDate | date:'dd/MM/yyyy') || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DELIVERY_ROUTE' | t }}</span>
        <span class="font-medium">{{ data.deliveryRoute || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DELIVERY_DATE' | t }}</span>
        <span class="font-medium">{{ (data.deliveryDate | date:'dd/MM/yyyy') || '-' }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.DELIVERY_HOUR' | t }}</span>
        <span class="font-medium">{{ data.deliveryHour || '-' }}</span>
      </div>
    </div>

    <!-- artículos: una sola lista, sea cual sea el número de documentos a generar -->
    <div class="flex flex-wrap items-center justify-between gap-2">
      <h3 class="text-base font-bold">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.TITLE' | t }}</h3>
    </div>
    <!-- móvil: tarjetas dentro de su propio contenedor con desplazamiento -->
    <div class="mt-3 max-h-[55vh] overflow-y-auto rounded-xl border p-3 md:hidden">
    <div class="flex flex-col gap-3">
      @for (item of data.items; track item.lineId) {
      <div class="flex flex-col rounded-xl border bg-card p-3">
        <div class="flex items-start gap-2">
          <div class="flex min-w-0 flex-1 flex-col">
            <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.LINE_NUMBER' | t }} {{ $index + 1 }}</span>
            <span class="inline-flex items-center gap-1.5 text-primary font-semibold">{{ item.code }}<app-bom-cell [material]="item.material" /></span>
            <span class="text-sm uppercase">{{ item.name }}</span>
            @if (allocationCount(item)) {
            <button type="button"
              class="mt-1 inline-flex w-fit items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 text-xs font-semibold text-primary hover:bg-primary-100 dark:bg-primary-900/30"
              [matTooltip]="'DOCUMENT_GENERATE.PREVIEW_MODAL.ALLOCATIONS_TOOLTIP' | t" (click)="openAllocations(item)">
              <mat-icon class="icon-size-4">warehouse</mat-icon>
              {{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.ALLOCATIONS_COUNT' | t: { count: allocationCount(item) } }}
            </button>
            } @else if (warehouseLabel(item)) {
            <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.FIELDS.WAREHOUSE' | t }}: {{ warehouseLabel(item) }}</span>
            }
          </div>
          <button mat-icon-button color="primary" type="button" class="-mr-2 -mt-1 shrink-0"
            [matTooltip]="'DOCUMENT_GENERATE.PREVIEW_MODAL.ITEM_DETAIL_TOOLTIP' | t" [matBadge]="detailCount(item) || null" matBadgeColor="accent"
            matBadgeSize="small" (click)="openDetail(item)">
            <mat-icon class="icon-size-5">description</mat-icon>
          </button>
        </div>

        <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t pt-3 text-sm">
          <div class="col-span-2 flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</span>
            <span class="font-semibold">{{ item.quantity }}</span>
          </div>
          <div class="col-span-2 flex items-center justify-between gap-2">
            <span class="text-secondary shrink-0">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</span>
            <div class="flex min-w-0 flex-col items-end">
              <span class="min-w-0 truncate" [matTooltip]="item.unitLabel">{{ item.unitLabel }}</span>
              @if (altUnits(item); as alt) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
              @if (alt.umsQty != null) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
              }
              @if (alt.umpQty != null) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
              }
              }
            </div>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.PRICE' | t }}</span>
            <span>{{ data.currency }}&nbsp;{{ item.price | dgNumber }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.SUBTOTAL' | t }}</span>
            <span>{{ data.currency }}&nbsp;{{ rowSubtotal(item) | dgNumber }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.DISCOUNT' | t }}</span>
            <span>{{ data.currency }}&nbsp;{{ item.discount | dgNumber }}</span>
          </div>
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.COLUMNS.TAX' | t }}</span>
            <span>{{ data.currency }}&nbsp;{{ item.isv | dgNumber }}</span>
          </div>
          <div class="col-span-2 flex items-center justify-between gap-2 border-t pt-2">
            <span class="text-secondary font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</span>
            <span class="text-primary text-base font-bold">{{ data.currency }}&nbsp;{{ rowTotal(item) | dgNumber }}</span>
          </div>
        </div>
      </div>
      } @empty {
      <div class="text-secondary flex h-24 items-center justify-center text-sm">{{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.EMPTY_ITEMS' | t }}</div>
      }
    </div>
    </div>

    <!-- desktop/tablet: tabla. El alto corta a la quinta línea y el resto se desplaza
         dentro de la tabla, sin empujar el resto de la vista previa -->
    <div class="mt-3 hidden max-h-[21rem] overflow-auto rounded-xl border md:block">
      <table class="w-full min-w-[980px] border-collapse text-base">
        <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            <th class="w-px whitespace-nowrap px-2 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.LINE_NUMBER' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
            <th class="px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRICE' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SUBTOTAL' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.DISCOUNT' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TAX' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          @for (item of data.items; track item.lineId) {
          <tr class="border-t">
            <td class="w-px whitespace-nowrap px-2 py-3 text-center">{{ $index + 1 }}</td>
            <td class="px-4 py-3">
              <div class="flex flex-col">
                <span class="inline-flex items-center gap-1.5 text-primary font-semibold">{{ item.code }}<app-bom-cell [material]="item.material" /></span>
                <span class="uppercase">{{ item.name }}</span>
                @if (allocationCount(item)) {
                <button type="button"
                  class="mt-0.5 inline-flex w-fit items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 text-xs font-semibold text-primary hover:bg-primary-100 dark:bg-primary-900/30"
                  [matTooltip]="'DOCUMENT_GENERATE.PREVIEW_MODAL.ALLOCATIONS_TOOLTIP' | t" (click)="openAllocations(item)">
                  <mat-icon class="icon-size-4">warehouse</mat-icon>
                  {{ allocationCount(item) }} almacenes
                </button>
                } @else if (warehouseLabel(item)) {
                <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-center">{{ item.quantity }}</td>
            <td class="px-4 py-3 text-left">
              <div class="flex flex-col items-start">
                <span class="inline-block max-w-[90px] truncate align-middle" [matTooltip]="item.unitLabel">{{ item.unitLabel }}</span>
                @if (altUnits(item); as alt) {
                <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                @if (alt.umsQty != null) {
                <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                }
                @if (alt.umpQty != null) {
                <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                }
                }
              </div>
            </td>
            <td class="px-4 py-3 text-right">{{ data.currency }}&nbsp;{{ item.price | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ data.currency }}&nbsp;{{ rowSubtotal(item) | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ data.currency }}&nbsp;{{ item.discount | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ data.currency }}&nbsp;{{ item.isv | dgNumber }}</td>
            <td class="px-4 py-3 text-right font-semibold">{{ data.currency }}&nbsp;{{ rowTotal(item) | dgNumber }}</td>
            <td class="px-4 py-3 text-center">
              <button mat-icon-button color="primary" type="button" [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.ITEM_DETAIL_TOOLTIP' | t"
                [matBadge]="detailCount(item) || null" matBadgeColor="accent" matBadgeSize="small"
                (click)="openDetail(item)">
                <mat-icon class="icon-size-5">description</mat-icon>
              </button>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="10">
              <div class="text-secondary flex h-24 items-center justify-center text-sm">{{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.EMPTY_ITEMS' | t }}</div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- comentarios, adjuntos y totales -->
    <div class="mt-6 flex flex-col gap-6 lg:flex-row lg:justify-between">
      <div class="flex min-w-0 flex-1 flex-col gap-6">
        @if (data.comments) {
        <div class="flex flex-col gap-1 lg:max-w-md">
          <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.NOTES' | t }}</span>
          <span class="font-medium">{{ data.comments }}</span>
        </div>
        }
        @if (data.attachments?.length) {
        <div class="flex flex-col gap-2 lg:max-w-xl">
          <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.ATTACHMENTS_COUNT' | t: { count: data.attachments.length } }}</span>
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
            @for (file of data.attachments; track $index) {
            <div class="flex items-center gap-2 rounded-lg border bg-gray-50 px-3 py-2 dark:bg-transparent">
              <mat-icon class="text-secondary icon-size-5 shrink-0">{{ attachmentIcon(file) }}</mat-icon>
              <div class="flex min-w-0 flex-1 flex-col">
                <span class="line-clamp-2 break-words text-sm font-medium" [matTooltip]="file.name">{{ file.name }}</span>
                <span class="text-secondary text-xs">{{ formatFileSize(file.size) }}</span>
              </div>
              <button mat-icon-button color="primary" type="button" class="shrink-0"
                [matTooltip]="'DOCUMENT_GENERATE.PREVIEW_MODAL.VIEW_ATTACHMENT' | t" (click)="openAttachment(file)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>
      <div class="w-full shrink-0 lg:max-w-xs lg:ml-auto">
        <div class="flex items-center justify-between py-1">
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.TOTALS.SUBTOTAL' | t }}</span>
          <span>{{ data.currency }}&nbsp;{{ data.summary.subtotal | dgNumber }}</span>
        </div>
        <div class="flex items-center justify-between py-1">
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.TOTALS.DISCOUNT' | t }}</span>
          <span class="text-green-600">-{{ data.currency }}&nbsp;{{ data.summary.discount | dgNumber }}</span>
        </div>
        <div class="flex items-center justify-between py-1">
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.TOTALS.TAX' | t }}</span>
          <span>{{ data.currency }}&nbsp;{{ data.summary.taxes | dgNumber }}</span>
        </div>
        <div class="mt-1 flex items-center justify-between border-t py-2">
          <span class="font-bold">{{ 'DOCUMENT_GENERATE.TOTALS.TOTAL' | t }}</span>
          <span class="text-primary text-lg font-bold">{{ data.currency }}&nbsp;{{ data.summary.total | dgNumber }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- footer -->
  <div class="flex flex-col justify-end gap-3 border-t bg-gray-50 px-6 dark:bg-transparent md:flex-row"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-stroked-button color="primary" type="button" (click)="confirmSameClient()">
      <mat-icon>person_add</mat-icon>
      {{ 'DOCUMENT_GENERATE.ACTIONS.GENERATE_AND_NEW_SAME_CLIENT' | t }}
    </button>
    <button mat-flat-button color="primary" type="button" (click)="confirm()">
      <mat-icon>check</mat-icon>
      {{ 'DOCUMENT_GENERATE.PREVIEW_MODAL.CONFIRM' | t }}
    </button>
  </div>
</div>
